export default __webpack_public_path__ + "static/media/screen-1.2c4d2f3d.jpg";